export default __webpack_public_path__ + "static/media/Hydropointer.4444af8a.png";